import React, { useState } from "react";
import { Box, Typography, Stack } from "@mui/material";
import CheckboxTree from "react-checkbox-tree";
import AccountCheckbox from "../../filters-panel/account-checkbox.jsx";
import {
  containsAdAnalyticsIntegration,
  containsWebsiteAnalyticsIntegration,
} from "../../../../utils/analytics-utils.js";

const EditReport = ({
  reportId,
  metricCheckList,
  setMetricCheckList,
  webAnalytics,
  setWebAnalytics,
  showAdAnalytics,
  setShowAdAnalytics,
  integrations,
  isAgencyView,
  nodes = [
    {
      value: "organic",
      label: "Organic Analytics",
      children: [
        {
          value: "overview",
          label: "Overview",
          children: [
            {
              value: "showOverviewFollowerData",
              label: "Audience Growth",
            },
            { value: "showOverviewExposureData", label: "Exposure" },
            {
              value: "showOverviewEngagementBreakdown",
              label: "Engagement Breakdown",
            },
            {
              value: "showOverviewEngagementRate",
              label: "Engagement Rate",
            },
            { value: "showOverviewPostPerformance", label: "Post Performance" },
            {
              value: "showHashtagAnalytics",
              label: "Hashtag Analytics",
            },
            {
              value: "showCategoryAnalytics",
              label: "Content Tag Analytics",
            },
          ],
        },
        { value: "showAccounts", label: "Accounts" },
        { value: "showInsights", label: "Insights" },
        {
          value: "showTopPosts",
          label: "Top Posts"
        }
      ],
    },
  ],
  expanded = ["organic", "overview"],
}) => {
  const [showEditReport, setShowEditReport] = useState(false);

  const onCheck = (checked) => {
    setMetricCheckList(checked);
  };

  const containsAdAnalytics =
    isAgencyView || containsAdAnalyticsIntegration(integrations);

  return (
    <Box>
      <Typography
        className="label"
        component="div"
        sx={{ cursor: "pointer" }}
        onClick={() => setShowEditReport(!showEditReport)}
      >
        Metrics
        <i
          class={`fa ${
            showEditReport ? "fa-chevron-down" : "fa-chevron-right"
          }`}
          aria-hidden="true"
        ></i>
      </Typography>

      {showEditReport && (
        <Box>
          <Box className="checkbox-tree">
            <CheckboxTree
              nodes={nodes}
              checked={metricCheckList}
              expanded={expanded}
              icons={{
                check: (
                  <img
                    className="icon-checkbox-alt"
                    src="https://d23ypky16g08sh.cloudfront.net/res/analytics/checked-icon.png"
                  />
                ),
                uncheck: <Box className="unchecked-alt" />,
                halfCheck: (
                  <img
                    className="icon-checkbox-alt half-check"
                    src="https://d23ypky16g08sh.cloudfront.net/res/analytics/checked-icon.png"
                  />
                ),
              }}
              onCheck={onCheck}
            />

            {!reportId && (
              <>
                <Box sx={{ marginTop: "20px" }}>
                  <AccountCheckbox
                    useAltCheckbox
                    checked={containsAdAnalytics && showAdAnalytics}
                    disabled={!containsAdAnalytics}
                    onChange={() => setShowAdAnalytics(!showAdAnalytics)}
                    label={
                      <Box>
                        <span>Ad Analytics</span>
                        {!containsAdAnalytics && (
                          <span className="tooltip-parent">
                            <i
                              className="fa fa-exclamation-triangle error-icon"
                              aria-hidden="true"
                            ></i>
                            <span
                              className="tooltip-overlay"
                              style={{
                                left: "10px",
                                bottom: "20px",
                                width: "300px",
                                top: "inherit",
                                fontSize: "14px",
                              }}
                            >
                              Please link a social media ad account from the
                              'Integrations' tab in your Brand Settings first.
                            </span>
                          </span>
                        )}
                      </Box>
                    }
                  />
                </Box>

                <Box className="web-analytics-block" sx={{ marginTop: "20px" }}>
                  <AccountCheckbox
                    useAltCheckbox
                    checked={webAnalytics.checked}
                    disabled={
                      !containsWebsiteAnalyticsIntegration(integrations)
                    }
                    onChange={() =>
                      setWebAnalytics({
                        ...webAnalytics,
                        checked: !webAnalytics.checked,
                      })
                    }
                    label={
                      <Box>
                        <span>Web Analytics</span>
                        {!containsWebsiteAnalyticsIntegration(integrations) && (
                          <span className="tooltip-parent">
                            <i
                              className="fa fa-exclamation-triangle error-icon"
                              aria-hidden="true"
                            ></i>
                            <span
                              className="tooltip-overlay"
                              style={{
                                left: "10px",
                                bottom: "20px",
                                width: "300px",
                                top: "inherit",
                                fontSize: "14px",
                              }}
                            >
                              Please link your Google Analytics account from the
                              'Integrations' tab in your Brand Settings first.
                            </span>
                          </span>
                        )}
                      </Box>
                    }
                  />

                  {webAnalytics.checked && !isAgencyView && (
                    <div className="web-acc-selector">
                      <div className="simple-filter">
                        <select
                          className="report-account-input content-holder rep-dropdown"
                          value={webAnalytics.accountId || ""}
                          onChange={(event) =>
                            setWebAnalytics({
                              ...webAnalytics,
                              accountId: event.target.value || "",
                            })
                          }
                        >
                          <option value=""></option>
                          {integrations
                            .filter(
                              (integration) =>
                                integration.appType === "GOOGLE_ANALYTICS" ||
                                integration.appType === "GOOGLE_ANALYTICS4"
                            )
                            .map((integration) => (
                              <option value={integration.accountId || ""}>
                                {integration.accountName ||
                                  integration.displayName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  )}
                </Box>
              </>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default EditReport;
